import React, {useMemo, useSyncExternalStore} from 'react'
import {ScreenSizeStore} from './screen-size-store'
import {ScreenSize} from './screen-size-constants'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export {ScreenSize}
// eslint-disable-next-line no-barrel-files/no-barrel-files
export type {ScreenSize as ScreenSizeType} from './screen-size-constants'

const screenBreakpoints: readonly ScreenSize[] = [
  ScreenSize.xxxxlarge,
  ScreenSize.xxxlarge,
  ScreenSize.xxlarge,
  ScreenSize.xlarge,
  ScreenSize.large,
  ScreenSize.medium,
  ScreenSize.small,
]

// Singleton store instance for the default breakpoints
const screenSizeStore = new ScreenSizeStore(screenBreakpoints, ScreenSize.small)

interface ScreenContextData {
  /**
   * Specifies the size of the current window
   */
  screenSize: ScreenSize
}

const ScreenContext = React.createContext<ScreenContextData>({screenSize: ScreenSize.small})

export function useScreenSize() {
  return React.use(ScreenContext)
}

interface Props {
  /**
   * @property {ScreenSize} [initialValue=ScreenSize.small] Initial value is useful to test react components that rely on ScreenContext.
   */
  initialValue?: ScreenSize
}

export function ScreenSizeProvider({children, initialValue = ScreenSize.small}: React.PropsWithChildren<Props>) {
  const screenSize = useSyncExternalStore(screenSizeStore.subscribe, screenSizeStore.getSnapshot, () => initialValue)

  const contextValue = useMemo(() => {
    return {screenSize}
  }, [screenSize])

  return <ScreenContext value={contextValue}>{children}</ScreenContext>
}

/**
 * Compute the screen size breakpoint for a given width.
 */
export function getCurrentSize(elementWidth: number): ScreenSize {
  return screenSizeStore.computeSize(elementWidth)
}
